import { TextSizes } from "@smartsuite/react-ui/lib";
import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";
import type { SwitchButtonStyles } from "@smartsuite/react-ui/lib/components/buttons/SwitchButton/SwitchButton.constant";
import { stylesSwitchButtonLight } from "@smartsuite/react-ui/lib/components/buttons/SwitchButton/SwitchButton.constant";

export const stylesWhiteSwitchButton: SwitchButtonStyles = {
  ...stylesSwitchButtonLight,
  borderRadius: 8,
  borderRadiusSlider: "7px",
  textSize: TextSizes.M,
  subTextSize: TextSizes.XS,
  subTextWeight: "regular",
  colorActiveHover: TextColorNames.primary,
};

export const SwitchWrapper = styled.div<{ $hasSubLabel: boolean }>`
  top: -2px;
  position: relative;

  .switch-button {
    width: 100%;
    height: auto;
    min-height: var(--height);
    align-items: stretch;
    padding: var(--padding-slider);
    overflow: visible;
  }

  .switch-button__item {
    flex: 1 1 0;
    height: auto;
    min-width: 0;
    padding: ${({ $hasSubLabel }) => ($hasSubLabel ? "8px" : "0")}
      var(--gap-item);
  }

  .switch-button__text_wrapper {
    width: 100%;
    gap: 2px;
  }

  .switch-button__item .text {
    display: block;
    width: 100%;
    text-align: center;
    white-space: normal;
  }

  .switch-button__item .sub_text {
    text-transform: none;
  }

  .switch-button__slider {
    height: auto;
    top: 2px;
    bottom: 2px;
  }
`;
